import { WabunkaChargeType as proto } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_charge_type';

import { captureWarning } from '@/wabunka-src/common/utils/sentry';

export const WabunkaChargeTypeList = ['PER_PERSON_WITH_MINIMUM_GUARANTEE', 'PER_GROUP', ''] as const;
export type WabunkaChargeType = (typeof WabunkaChargeTypeList)[number];

export const wabunkaChargeTypeLabelList = ['person', 'group', ''] as const;
export type WabunkaChargeTypeLabel = (typeof wabunkaChargeTypeLabelList)[number];

/**
 * proto の型からフロントエンド用のモデルの型（union type）に変換して返却する
 */
export const buildWabunkaChargeType = (res: proto): WabunkaChargeType => {
  switch (res) {
    case proto.PER_PERSON_WITH_MINIMUM_GUARANTEE:
      return 'PER_PERSON_WITH_MINIMUM_GUARANTEE';
    case proto.PER_GROUP:
      return 'PER_GROUP';
    default:
      captureWarning(`buildWabunkaChargeType: unknown charge type: ${res}`, 'wabunka');
      return '';
  }
};
/**
 * charge を引数に取り、ラベルを返却する
 * @param {WabunkaChargeType} charge - 通訳
 * @returns {WabunkaChargeTypeLabel} - ラベル（日本語）
 */
export const getWabunkaChargeTypeLabel = (charge: WabunkaChargeType): WabunkaChargeTypeLabel => {
  switch (charge) {
    case 'PER_PERSON_WITH_MINIMUM_GUARANTEE':
      return 'person';
    case 'PER_GROUP':
      return 'group';
    default:
      captureWarning(`getWabunkaChargeTypeLabel: unknown charge type: ${charge}`, 'wabunka');
      return '';
  }
};
